'use client'

import { OutlineButton, Text } from '@macarongfactory/web-ui'

import {
  RANK_TRACK_CODE,
  RANK_VISIBLE_LIMIT,
  useRankImpression,
  useRankTrackingContext,
} from '../_features/rank'

interface IRankMoreCtaProps {
  /** 세그먼트 전체 차량 수 */
  totalCount: number
  /** 버튼 문구 (데스크탑 '마이클에서 전체보기' / 모바일 '앱에서 전체보기') */
  buttonText: string
  /** 전체보기 클릭 (앱 진입 유도) */
  onMoreClick: () => void
}

/**
 * 랭킹 더보기 CTA — Figma 9241:28086 (type=default / type=10개 이하)
 * 노출 상한(10위) 이후는 감추고 앱 설치로 유도한다.
 * - 10위 초과: '실시간으로 {N}개 차량 랭킹' (개수 노출) — 상단에 흐릿한 미리보기 행(RankList)
 * - 10개 이하: '실시간 랭킹' (개수 미노출) — Figma 주석 "10개 이하로 랭킹 리스트가 존재하는 경우 노출"
 */
const RankMoreCta = ({
  totalCount,
  buttonText,
  onMoreClick,
}: IRankMoreCtaProps) => {
  const track = useRankTrackingContext()
  const ref = useRankImpression<HTMLDivElement>(() =>
    track.itemShow(RANK_TRACK_CODE.RANK_MORE, 'section', '앱에서 전체보기 유도')
  )

  const hasMore = totalCount > RANK_VISIBLE_LIMIT
  const message = hasMore
    ? `마이클 앱에서 실시간으로\n${totalCount.toLocaleString()}개 차량 랭킹을 볼 수 있어요`
    : '마이클 앱에서 실시간 랭킹을 볼 수 있어요'

  const handleClick = () => {
    track.itemClick(RANK_TRACK_CODE.RANK_MORE, 'button', '앱에서 전체보기 클릭')
    onMoreClick()
  }

  return (
    <div
      ref={ref}
      className='flex flex-col items-center justify-center gap-dimension-x3 px-dimension-x16 py-dimension-x14'
    >
      <Text
        variant='title-1-semibold'
        color='text-foreground-neutral-strong'
        className='block whitespace-pre-line text-center'
      >
        {message}
      </Text>
      <OutlineButton
        text={buttonText}
        variant='brand'
        size='medium'
        clickable={handleClick}
      />
    </div>
  )
}

export default RankMoreCta
